import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["steps", "formLoop", "onStepChange", "getActiveStepElements", "stepperGridProps", "stepGridProps", "value"];
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { Button, Grid, MobileStepper } from "@mui/material";
import { useEffect } from "react";
export function FormMobileStepper(props) {
    var _ref;
    var _a = props.steps, steps = _a === void 0 ? [] : _a, formLoop = props.formLoop, onStepChange = props.onStepChange, getActiveStepElements = props.getActiveStepElements, stepperGridProps = props.stepperGridProps, stepGridProps = props.stepGridProps, value = props.value, others = _objectWithoutProperties(props, _excluded);
    var activeStepNumber = Number(value);
    var maxSteps = steps === null || steps === void 0 ? void 0 : steps.length;
    var currStep = (_ref = getActiveStepElements ? getActiveStepElements(activeStepNumber, steps[activeStepNumber]) : steps[activeStepNumber]) === null || _ref === void 0 ? void 0 : _ref.elements;
    var handleNav = function (e) {
        if (!onStepChange)
            return;
        var type = e.currentTarget.id;
        switch (type) {
            case 'next':
                onStepChange(e, activeStepNumber + 1);
                break;
            case 'prev':
                onStepChange(e, activeStepNumber - 1);
                break;
            default:
                break;
        }
    };
    useEffect(function () {
        onStepChange && onStepChange(undefined, 0);
    }, []);
    return /*#__PURE__*/ React.createElement(Grid, _extends({
        container: true,
        item: true,
        spacing: 2,
        alignItems: "end"
    }, stepperGridProps), formLoop && (currStep === null || currStep === void 0 ? void 0 : currStep.map(formLoop)), /*#__PURE__*/ React.createElement(Grid, _extends({
        item: true,
        xs: 12
    }, stepGridProps), /*#__PURE__*/ React.createElement(MobileStepper, _extends({
        steps: maxSteps,
        position: "static",
        activeStep: activeStepNumber,
        nextButton: /*#__PURE__*/ React.createElement(Button, {
            id: "next",
            size: "small",
            onClick: handleNav,
            endIcon: /*#__PURE__*/ React.createElement(KeyboardArrowRight, null),
            disabled: activeStepNumber === maxSteps - 1,
            sx: {
                background: 'none'
            }
        }, "Next"),
        backButton: /*#__PURE__*/ React.createElement(Button, {
            id: "prev",
            size: "small",
            onClick: handleNav,
            startIcon: /*#__PURE__*/ React.createElement(KeyboardArrowLeft, null),
            disabled: activeStepNumber === 0,
            sx: {
                background: 'none'
            }
        }, "Previous")
    }, others))));
}
